<template>
    <link-layout
        class="nav-item nav-link"
        :class="{'active': active}"
        :label="label"
        :href="route(href)"
        :variant="variant"
        inertia-link
    >
        <template #start>
            <font-awesome-icon :icon="icon" :class="['d-lg-none']"></font-awesome-icon>
        </template>

    </link-layout>
</template>

<script>
import LinkLayout from '@/shared/LinkLayout.vue'

export default {
    components: {
        LinkLayout,
    },
    props: {
        href: String,
        label: String,
        icon: String,
        active: Boolean,
        variant: {type: String, default: null},
    },
}
</script>
